var map = {
	"./basic.jpg": "b91a",
	"./basic_big.jpg": "2f99",
	"./lumax.jpg": "45ae",
	"./lumax_big.jpg": "622d",
	"./overview.jpg": "4011",
	"./protect.jpg": "e568",
	"./protect_big.jpg": "6890",
	"./silent.jpg": "1267",
	"./silent_big.jpg": "65b3",
	"./smarttec.jpg": "3664",
	"./smarttec_big.jpg": "156d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d928";